"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _componentsBase = require("@telus-uds/components-base");
var _constants = require("../constants");
var _staticContent = require("../staticContent");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _FieldWrapper = _interopRequireDefault(require("../FieldWrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var MIN_FILE_SIZE_IN_MB = 0.1;
var MAX_FILE_SIZE_IN_MB = 10;
var FileUploadField = props => {
  var {
    onChange = () => {},
    isRequired = false,
    maxFilesCount = 5,
    minFilesCount = 1,
    maxFileSize = MAX_FILE_SIZE_IN_MB,
    minFileSize = MIN_FILE_SIZE_IN_MB,
    language = _constants.CONTENTFUL_LOCALE.en,
    allowedFileTypes = _constants.FILE_EXTENSIONS.IMAGES,
    clickedSubmit = false,
    inputRef = /*#__PURE__*/_react.default.createRef()
  } = props;
  var [isEmptyWhenSubmitted, setIsEmptyWhenSubmitted] = (0, _react.useState)(false);
  var allowMultipleFiles = maxFilesCount > 1;
  var validate = (0, _react.useCallback)(() => {
    var _inputRef$current;
    var files = inputRef === null || inputRef === void 0 || (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.files;
    if (isRequired && (files === null || files === void 0 ? void 0 : files.length) === 0) {
      return false;
    }
    return true;
  }, [inputRef, isRequired]);
  var onFileUpload = files => {
    inputRef.current.files = [];
    var results = files.map(file => {
      inputRef.current.files.push(file);
      return file;
    });
    setIsEmptyWhenSubmitted(false);
    onChange(inputRef.current.files, validate());
    return results;
  };
  var onFileDelete = file => {
    var updatedFiles = Array.from(inputRef.current.files).filter(f => !((f === null || f === void 0 ? void 0 : f.name) === (file === null || file === void 0 ? void 0 : file.name) && (f === null || f === void 0 ? void 0 : f.type) === (file === null || file === void 0 ? void 0 : file.type)));
    inputRef.current.files = updatedFiles;
    onChange(inputRef.current.files, validate());
    return file;
  };
  (0, _react.useEffect)(() => {
    var _inputRef$current2;
    if (inputRef !== null && inputRef !== void 0 && inputRef.current && ((_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 ? void 0 : _inputRef$current2.files) === undefined) {
      inputRef.current.files = [];
    }
  }, [inputRef]);
  (0, _react.useEffect)(() => {
    var _inputRef$current3;
    onChange(inputRef === null || inputRef === void 0 || (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.files, validate());
  }, [inputRef, onChange, validate]);
  (0, _react.useEffect)(() => {
    if (clickedSubmit) {
      if (!validate()) {
        setIsEmptyWhenSubmitted(true);
      }
    }
  }, [clickedSubmit, validate]);
  return /*#__PURE__*/_react.default.createElement(_FieldWrapper.default, null, /*#__PURE__*/_react.default.createElement(_componentsBase.FileUpload, {
    ref: inputRef,
    copy: language,
    fileTypes: allowedFileTypes,
    allowMultipleFiles: allowMultipleFiles,
    maxFileSize: maxFileSize,
    maxFilesCount: maxFilesCount,
    minFileSize: minFileSize,
    minFilesCount: minFilesCount,
    onUpload: onFileUpload,
    onDelete: onFileDelete
  }), isEmptyWhenSubmitted && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_componentsBase.Spacer, {
    space: 2
  }), /*#__PURE__*/_react.default.createElement(_componentsBase.Notification, {
    variant: {
      validation: 'error'
    },
    tokens: {
      color: '#c12335',
      borderBottomWidth: 0,
      borderTopWidth: 0,
      borderLeftWidth: 0,
      borderRightWidth: 0
    }
  }, _staticContent.FILE_UPLOAD_FIELD.VALIDATION_ERROR_NO_INPUT[language])));
};
FileUploadField.propTypes = {
  onChange: _propTypes.default.func,
  isRequired: _propTypes.default.bool,
  maxFilesCount: _propTypes.default.number,
  minFilesCount: _propTypes.default.number,
  maxFileSize: _propTypes.default.number,
  minFileSize: _propTypes.default.number,
  language: _propTypes.default.string,
  allowedFileTypes: _propTypes.default.array,
  clickedSubmit: _propTypes.default.bool,
  inputRef: _propTypes.default.object
};
var _default = exports.default = FileUploadField;